import { render, staticRenderFns } from "./barter.vue?vue&type=template&id=6f083528&scoped=true"
import script from "./barter.vue?vue&type=script&lang=js"
export * from "./barter.vue?vue&type=script&lang=js"
import style0 from "./barter.vue?vue&type=style&index=0&id=6f083528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f083528",
  null
  
)

export default component.exports